"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var classnames_1 = require("classnames");
var mapStateToProps = function (state) { return (__assign({}, state.hfilter)); };
var mapDispatchToProps = function (dispatch) { return ({
    onSortMoreClicked: function () { return dispatch(HfilterAction_1.default.onSortMoreToggle()); },
    onSortOptionClicked: function (option) { return dispatch(HfilterAction_1.default.onSortOptionClicked(option)); },
}); };
var HfilterSortDropdown = function (props) {
    var sortPanelClass = classnames_1.default(['c-hfilterbox__panel', { 'c-hfilterbox__panel--active': props.sortPanelActive }]);
    var renderSortOption = function (option, index) {
        var onClick = function () { return props.onSortOptionClicked(option); };
        return (React.createElement("a", { key: index, onClick: onClick, className: "c-hfilterpanel__option " + (option.selected ? 'c-hfilterpanel__option--active' : '') }, option.name));
    };
    return (React.createElement("div", { className: "c-hfilter__more" },
        React.createElement("a", { onClick: props.onSortMoreClicked, className: "c-hfilter__more-btn" },
            props.sortOptions.find(function (it) { return it.selected; }).value === 0 ? props.t.sortBy : props.sortOptions.find(function (it) { return it.selected; }).name,
            React.createElement("span", { className: "fal fa-chevron-down" })),
        React.createElement("div", { className: sortPanelClass },
            React.createElement("div", { className: "c-hfilterpanel" },
                React.createElement("div", { className: "c-hfilterpanel__head" },
                    React.createElement("div", { className: "c-hfilterpanel__title l-pad" }, props.t.sortBy)),
                React.createElement("div", { className: "c-hfilterpanel__body" },
                    React.createElement("div", { className: "c-hfilterpanel__options" }, props.sortOptions.map(renderSortOption))),
                React.createElement("div", { className: "c-hfilterpanel__foot" })))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(HfilterSortDropdown);
